import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetCompanyInfoRequest,
  GetCompanyInfoResponse,
  UpdateCompanyInfoRequest,
  UpdateCompanyInfoResponse,
} from "../../models/CompanyInfo.model";
import { CreateNewCompanyRequest, CreateNewCompanyResponse } from "../../models/Company.model";

const API_BASE_URL = environment.apiUrl;
export const createNewCompany = createAsyncThunk<
  CreateNewCompanyResponse,
  CreateNewCompanyRequest,
  { rejectValue: string }
>("company/createNewCompany", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Company/CreateNewCompany`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: CreateNewCompanyResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to create new company");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});
export const getCompanyInfo = createAsyncThunk<
  GetCompanyInfoResponse,
  GetCompanyInfoRequest,
  { rejectValue: string }
>("company/getCompanyInfo", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Company/GetCompanyInfo`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetCompanyInfoResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch company info");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

// יצירת/עדכון תפריט בסיס
export const updateCompanyInfo = createAsyncThunk<
  UpdateCompanyInfoResponse,
  UpdateCompanyInfoRequest,
  { rejectValue: string }
>("company/updateCompanyInfo", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Company/UpdateCompanyInfo`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: UpdateCompanyInfoResponse = await response.json();

    if (!data.success)
      return rejectWithValue(
        data.message || "Failed to create/update company info"
      );
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});
